// Comandos do agregado Categoria — criar, renomear, inativar/reativar. A
// Categoria só classifica o Tipo de Peça (ADR-0006); é gerida por um modal,
// não por tela própria. Dado puro; o executor só chama o domínio.

import type { Snapshot } from "../domain/snapshot.ts";
import {
  criarCategoria,
  definirAtivoCategoria,
  editarCategoria,
} from "../domain/categorias.ts";
import { assertNunca } from "../lib/assert-nunca.ts";
import { comoObjeto, exigirBooleano, exigirTexto, texto } from "./_forma.ts";
import type { ContextoComando } from "./lotes.ts";

export type ComandoCategoria =
  | { tipo: "criar"; nome: string }
  | { tipo: "editar"; id: string; nome: string }
  | { tipo: "definirAtivo"; id: string; ativo: boolean };

export function executarComandoCategoria(
  snapshot: Snapshot,
  cmd: ComandoCategoria,
  _ctx: ContextoComando,
): Snapshot {
  switch (cmd.tipo) {
    case "criar":
      return criarCategoria(snapshot, { nome: cmd.nome });
    case "editar":
      return editarCategoria(snapshot, cmd.id, { nome: cmd.nome });
    case "definirAtivo":
      return definirAtivoCategoria(snapshot, cmd.id, cmd.ativo);
    default:
      return assertNunca(cmd);
  }
}

export function validarComandoCategoria(valor: unknown): ComandoCategoria {
  const c = comoObjeto(valor, "Comando de categoria");
  switch (c.tipo) {
    case "criar":
      return { tipo: "criar", nome: texto(c.nome) };
    case "editar":
      return {
        tipo: "editar",
        id: exigirTexto(c.id, "id"),
        nome: texto(c.nome),
      };
    case "definirAtivo":
      return {
        tipo: "definirAtivo",
        id: exigirTexto(c.id, "id"),
        ativo: exigirBooleano(c.ativo, "ativo"),
      };
    default:
      throw new Error(
        `Tipo de comando de categoria desconhecido: ${String(c.tipo)}.`,
      );
  }
}
